import { render, staticRenderFns } from "./AfterInfo.vue?vue&type=template&id=620e7b3e&scoped=true&"
import script from "./AfterInfo.vue?vue&type=script&lang=js&"
export * from "./AfterInfo.vue?vue&type=script&lang=js&"
import style0 from "./AfterInfo.vue?vue&type=style&index=0&id=620e7b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e7b3e",
  null
  
)

export default component.exports